import React from 'react';
import AccordionTable from "../../../../../../common/AccordionTable";
import {LotItem, LotList, LotWithItemList} from "../../../../../../types/lot";
import {useTranslation} from "react-i18next";

interface LotsTableProps<PARENT, CHILD> {
    lotsData: PARENT[];
    totalCount: number;
    page: number;
    pageSize: number;
    companyId: number;
    setPage: (newPage: number) => void;
    setPageSize: (newPageSize: number) => void;
    noChildrenMessage: string;
    loading: boolean;
    expandAll?: boolean;
    selectedRows?: (lots: PARENT[]) => void;
}

const LotsTable: React.FC<LotsTableProps<LotWithItemList, LotItem>> = (
    {
        lotsData,
        totalCount,
        page,
        pageSize,
        companyId,
        setPage,
        setPageSize,
        noChildrenMessage,
        loading,
        expandAll = false,
        selectedRows,
    }
)  => {

    const {t} = useTranslation();

    const parentHeaders: { id: keyof LotList; label: string, col: { type: "dictionary" | "common" | "itn", dictName?: string} }[] = [
        {id: 'id' as keyof LotList, label: t('cabinet.lots.table.headers.id'), col: {type: "common"}},
        {id: 'companyName' as keyof LotList, label: t('cabinet.lots.table.headers.companyName'), col: {type: "common"}},
        {id: 'itn' as keyof LotList, label: t('cabinet.lots.table.headers.itn'), col: {type: "itn"}},
        {id: 'state' as keyof LotList, label: t('cabinet.lots.table.headers.state'), col: {type: "dictionary", dictName: "lot_state" }},
        {id: 'auctionDate' as keyof LotList, label: t('cabinet.lots.table.headers.auctionDate'), col: {type: "common"}},
        {id: 'createdAt' as keyof LotList, label: t('cabinet.lots.table.headers.createdAt'), col: {type: "common"}},
        {id: 'itemCount' as keyof LotList, label: t('cabinet.lots.table.headers.itemCount'), col: {type: "common"}},
        {id: 'gross' as keyof LotList, label: t('cabinet.lots.table.headers.gross'), col: {type: "common"}},
        {id: 'year' as keyof LotList, label: t('cabinet.lots.table.headers.year'), col: {type: "common"}},
    ];

    const childHeaders = [
        {id: 'productCode' as keyof LotItem, label: t('cabinet.lots.items.headers.productCode')},
        {id: 'productName' as keyof LotItem, label: t('cabinet.lots.items.headers.productName')},
        {id: 'productBrief' as keyof LotItem, label: t('cabinet.lots.items.headers.productBrief')},
        {id: 'amount' as keyof LotItem, label: t('cabinet.lots.items.headers.amount')},
        {id: 'gross' as keyof LotItem, label: t('cabinet.lots.items.headers.gross')},
        {id: 'unitName' as keyof LotItem, label: t('cabinet.lots.items.headers.unitName')},
    ];

    const handlePageChange = (newPage: number) => {
        setPage(newPage);
    };

    const handlePageSizeChange = (newPageSize: number) => {
        setPageSize(newPageSize);
    };

    const getChildTitle = (parent: LotWithItemList) => {
        return `Элементы лота #${parent.id}`;
    };

    return (
        <div>
            {loading ? (
                <p>Загрузка данных...</p>
            ) : (
                <AccordionTable<LotWithItemList, LotItem>
                    data={lotsData}
                    childrenField="lotItems"
                    parentHeaders={parentHeaders}
                    childHeaders={childHeaders}
                    totalCount={totalCount}
                    page={page}
                    pageSize={pageSize}
                    onPageChange={handlePageChange}
                    onPageSizeChange={handlePageSizeChange}
                    childTitle={getChildTitle}
                    noChildrenMessage="У этого лота нет элементов"
                    expandAll={expandAll}
                    onSelectionChange={selectedRows}
                />
            )}
        </div>
    );
};

export default LotsTable;